/**
 * @author [Sam]
 * @desc [This interceptor Provides Spinner Show and Hide for all API requests and its exlcudes the ping sessios API
 *  Exclude component level spinner modules]
 */
import { NGXLogger } from 'ngx-logger';
import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import {InterceptorSkipHeader, silentSpinner} from "../constants/api-enums";
import { CommonService } from 'src/Services/common.service';




@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  count = 0;
  constructor(private injector: Injector, private logger: NGXLogger, private commonService: CommonService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.logger.debug('Request Entering LoaderInterceptor');
    const loaderService = this.injector.get(NgxSpinnerService);
    if (req.headers.has(InterceptorSkipHeader)) {
      const headers = req.headers.delete(InterceptorSkipHeader);
      this.logger.debug('InterceptorSkipHeader is present skipping Spinner show');
      return next.handle(req.clone({ headers }));
    }
      // loaderService.show(silentSpinner);
      this.count++;

    return next.handle(req).pipe(
      finalize(() => {
        this.count--;
        this.logger.debug('Request Count->' + this.count);
        if (this.count === 0 ) {
          // loaderService.hide('silentSpinner');
          this.logger.debug('Spinner Hide');
        }
      })
    );
  }
}
